'use strict';

const config    = require('config');
const moment    = require('moment');
const BaseModel = require('./Base');

let Model;

module.exports = Model = BaseModel.extend('Payroll', {
    softDelete: false,

    defaults: {
        company:            null,
        submittedDate:      null,
        chequePickupDate:   null,
        periodDate:         null,
        status:             0,
        lastEditedEmployee: null,
        employeeEpf:        0,
        employeeSocso:      0,
        employerEpf:        0,
        employerSocso:      0,
        mtd:                0,
        cp38:               0,
        zakat:              0,
        grossPay:           0,
        netPay:             0,
        base:               0,
        additions:          0,
        deductions:         0,
        payslips:           0
    },

    constraints: {
        company: {presence: true},
        status:  {
            presence:     true,
            numericality: {
                onlyInteger:          true,
                greaterThanOrEqualTo: 0,
                lessOrEqualThan:      0
            }
        }
    },

    setters: {
        status: function(value) {
            return !_.isNaN(parseInt(value, 10)) ? parseInt(value, 10) : value;
        }
    },

    isCreated: function() {
        return (this.get('status') || 0) === 0;
    },

    isComplete: function() {
        return (this.get('status') === 9);
    },

    getStatusLabel: function() {
        if (this.get('status') < 3) {
            return 'Saved';
        } else if (this.get('status') === 9) {
            return 'Complete';
        } else {
            return 'Submitted';
        }
    },

    run: function(includeAllEmployees) {
        return Parse.Cloud.run('runPayroll', {
            payrollId:           this.id,
            includeAllEmployees: includeAllEmployees
        }).then(function(res) {
            if (res instanceof Parse.Object) {
                this.trigger('run-complete', this);
                return Parse.Promise.as(res);
            }

            this.trigger('running', this);
            return this.whenDone(res.job).then(function() {
                this.trigger('run-complete', this);
                return Parse.Promise.as(this);
            }.bind(this));
        }.bind(this));
    },

    whenDone: function(jobId) {
        var timeout;
        var promise    = new Parse.Promise();
        var pollStatus = function() {
            Parse.Cloud.run('payrollJobStatus', {
                jobId:     jobId,
                payrollId: this.id
            }).then(function(res) {
                if (res.done === true) {
                    clearTimeout(timeout);
                    promise.resolve(this);
                    return;
                }

                timeout = setTimeout(pollStatus, 2000);
            }.bind(this), function(err) {
                clearTimeout(timeout);
                promise.reject(err);
            });
        }.bind(this);

        pollStatus();

        return promise;
    },

    hasPendingJobs: function() {
        return Parse.Cloud.run('payrollHasPendingJobs', {
            payrollId: this.id
        });
    },

    sync: function(integration) {
        return Parse.Cloud.run('payrollSync', {
            provider: integration.get('provider'),
            integrationId: integration.id,
            payrollId: this.id
        });
    },

    isCurrentPeriod: function() {
        return (
            this.getPeriod().month() ===
                moment(this.getPeriodFromDate()).month()
        );
    },

    getPeriod: function() {
        if (this.get('periodDate')) {
            return moment(this.get('periodDate'));
        }

        return moment(this.getPeriodFromDate(
            this.get('submittedDate') || Date.now()
        ));
    },

    samePeriodAs: function(payroll) {
        return this.getPeriod().isSame(payroll.getPeriod(), 'month');
    },

    getPeriodFromDate: function(date) {
        var m = moment(date || Date.now());

        if (m.date() < config.periodStartDate) {
            m.subtract(1, 'month');
        }

        return m.toDate();
    },

    getPeriodFormatted: function() {
        return this.getPeriod().format('MMMM YYYY');
    },

    generateForms: function() {
        return Parse.Cloud.run('generatePayrollForms', {
            payrollId: this.id
        });
    },

    sendPayslips: function(payslips) {
        return Parse.Cloud.run('sendPayslips', {
            payrollId: this.id,
            payslips: payslips
        });
    },

    resetEmployee: function(employee) {
        var employeeId = typeof employee === 'string' ? employee : employee.id;

        return Parse.Cloud.run('payrollResetEmployee', {
            payrollId:  this.id,
            employeeId: employeeId
        });
    },

    resetUnpaidLeave: function() {
        return Parse.Cloud.run('payrollResetUnpaidLeave', {
            payrollId: this.id
        });
    },

    revert: function(opts = {}) {
        return Parse.Cloud.run('revertPayroll', {
            payrollId: this.id,
            savedPayrollAction: opts.savedPayrollAction
        });
    },

    createArchive: function() {
        return Parse.Cloud.run('createPayrollArchiveFile', {
            payrollId: this.id,
            companyId: this.get('company').id
        });
    },

    makeArchiveDownloadable: function() {
        return Parse.Cloud.run('makeArchiveDownloadable', {
            payrollId: this.id
        });
    }
}, {
    getCurrentPeriodDate: function() {
        let periodStart = moment().date() < config.periodStartDate ?
            moment().subtract(1, 'month').startOf('month') :
            moment().startOf('month');

        return periodStart.toDate();
    },

    fetchById: function(id) {
        return (new Parse.Query('Payroll')).get(id);
    },

    fetchCurrent: function(company) {
        return (new Parse.Query('Payroll'))
            .include('company')
            .descending('createdAt')
            .lessThanOrEqualTo('status', 2)
            .equalTo('company', company)
            .first();
    },

    fetchForUser: function(user) {
        return (new Parse.Query('Company'))
            .equalTo('user', user)
            .first();
    }
});



// WEBPACK FOOTER //
// ./app/models/Payroll.js